import React from 'react';

import OnHoverTooltip from '../../../../tables/shared/OnHoverTooltip';

const lightTextColor = '#f5f5f5';
const darkTextColor = '#212529';

const rgbToYIQ = ({ r, g, b }) => {
    return (r * 299 + g * 587 + b * 114) / 1000;
};

const hexToRgb = (hex) => {
    if (!hex || hex === undefined || hex === '') {
        return undefined;
    }

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : undefined;
};

const contrast = (colorHex, threshold = 128) => {
    if (colorHex === undefined) {
        return darkTextColor;
    }

    const rgb = hexToRgb(colorHex);

    if (rgb === undefined) {
        return darkTextColor;
    }

    return rgbToYIQ(rgb) >= threshold ? darkTextColor : lightTextColor;
};

const LabelTag = ({ value }) => {
    const tagComponent = (
        <div className='label-tag' style={{ backgroundColor: value.color, color: contrast(value.color) }}>
            {value.name}
        </div>
    );

    if (value.description) {
        return (
            <OnHoverTooltip isSlimmed tooltipPlace='right' delay={{ show: 250, hide: 50 }}>
                {tagComponent}
                {value.description}
            </OnHoverTooltip>
        );
    } else {
        return tagComponent;
    }
};

export default LabelTag;
